module.exports = __webpack_public_path__ + "static/img/2.52d149f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news18/2.png
// module id = O5sM
// module chunks = 1